<div class="no_data_card" [ngClass]="{'ndc_height_card':minheight}">
  <div class="ndc_inner_card">
    <img src="assets/images/no_data_img.svg" alt="">
    <p>{{msg}}</p>
  </div>
</div>
